<template>
  <v-menu open-on-hover offset-y>
    <template v-slot:activator="{ on, attrs}">
      <v-btn text icon color="primary" class="mr-2" v-bind="attrs" v-on="on">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>

    <v-list dense
            nav>
      <v-list-item link :to="{ name: 'EmployeeInterviewsDashboard'}" v-if="client !== 'Hof'">
        <img src="@/assets/employee-interview-primary.svg" height="24px" alt="Mitarbeiter-Gepräche" class="mr-2"/>
        <v-list-item-title class="primary--text">Mitarbeitergespräche</v-list-item-title>
      </v-list-item>

      <v-list-item link :to="{ name: 'IdeasWorkbenchDashboard' }" v-if="$can('view ideasWorkbench')">
        <img src="@/assets/ideas-workbench-primary.svg" height="24px" alt="Werkbank" class="mr-2"/>
        <v-list-item-title class="primary--text">WerkBank</v-list-item-title>
      </v-list-item>

      <v-list-item link disabled v-else-if="client !== 'Hof'">
        <img src="@/assets/ideas-workbench.svg" height="24px" alt="Werkbank" class="mr-2"/>
        <v-list-item-title>WerkBank</v-list-item-title>
      </v-list-item>

      <v-list-item link disabled v-if="client !== 'Hof'">
        <img src="@/assets/trainee-planning.svg" height="24px" alt="Azubiplanung" class="mr-2"/>
        <v-list-item-title>Azubiplanung</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "app-layout-navbar-apps",
  computed: {
    isDemo: function () {
      return process.env.VUE_APP_DEMO;
    },
    client() {
      return process.env.VUE_APP_CLIENT;
    }
  },
}

</script>

<style scoped>

</style>
